import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import { GetProjectFoldersQuery } from '@/gql/graphql';
import { useMemo } from 'react';

const GET_PROJECT_FOLDERS = graphql(`
  query GetProjectFolders($projectId: ID!) {
    projectById(id: $projectId) {
      id
      folders {
        id
        parentId
        isDeletable {
          result
          reasons
        }
        name
        isRoot
      }
    }
  }
`);

export type TFolder = GetProjectFoldersQuery['projectById']['folders'][number];

const useGetProjectFolders = (projectId?: string) => {
  const { data, ...rest } = useQuery({
    enabled: !!projectId,
    queryKey: projectKeys.folders(projectId!),
    queryFn: () => {
      return gqlClient.request(GET_PROJECT_FOLDERS, {
        projectId: projectId!,
      });
    },
  });

  const projectRootFolder = data?.projectById.folders?.find(
    (folder) => folder.isRoot
  );

  const nonRootProjectFolders = useMemo(() => {
    return data?.projectById.folders?.filter((folder) => !folder.isRoot);
  }, [data]);

  return {
    data,
    projectFolders: data?.projectById.folders,
    nonRootProjectFolders,
    projectRootFolder,
    ...rest,
  };
};

export default useGetProjectFolders;
